import React from 'react'
import Drawer from 'components/Drawer'
import { Avatar, Button, Modal, Spin } from 'antd'
import styled from 'styled-components'
import { getApprovalRequests, approveApprovalRequest, rejectApprovalRequest, bulkApproveApprovalRequests } from 'modules/TPOApproval/actions'
import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import approveImg from 'components/Images/duplicate.png'
import rejectImg from 'components/Images/OBJECTS.png'
import ApprovedIcon from 'components/icons/ApprovedIcon'
import { createGlobalStyle } from 'styled-components'
import ReactDOMServer from 'react-dom/server'
import ProfileApprovalTemplate from 'components/EmailTemplate/ProfileApprovalTemplate'
import ProfileRejectedTemplate from 'components/EmailTemplate/ProfileRejectedTemplate'
import { sendNotificationBulkEmail } from 'modules/Students/actions'
import PaperClip from 'components/icons/PaperClip'
import { CloseOutlined } from '@ant-design/icons'
import AntdAvatar from 'components/Avatar'
import { useNavigate } from 'react-router-dom'
import SuccessMessage from '../../../../utils/SuccessMessage'
import {studentsMetricsData} from '../../../Students/actions'
import { getTPOMetrics } from '../../../TPORequests/actions'
const SuccessModalStyle = createGlobalStyle`
  .success-modal .ant-modal-content {
    background: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
  }

  .success-modal .ant-modal-body {
    padding: 0 !important;
  }
`


const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const UserRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`

const Name = styled.div`
  font-size: 16px;
  font-weight: 600;
`

const Meta = styled.div`
  font-size: 13px;
  color: #6b7280;
`

const SectionTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-top: 12px;
`

const Table = styled.div`
width: 800;
height: 205;
angle: 0 deg;
opacity: 1;

  border: 1px solid #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
`

const TableHeader = styled.div`
width: 800;
height: 43;
angle: 0 deg;
opacity: 1;

  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;

`

const TableRow = styled.div`
width: 800;
height: 54;
angle: 0 deg;
opacity: 1;
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  border-bottom: 1px solid #e5e7eb;

  &:last-child {
    border-bottom: none;
  }
`

const Cell = styled.div`
  padding: 10px;
  border-right: 1px solid #e5e7eb;

  display: flex;
  align-items: center; 
  text-align: left;

  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;

  &:last-child {
    border-right: none;
  }
`

const HeaderCells = styled.div`
width: 200;
height: 43;
gap: 10px;
angle: 0 deg;
opacity: 1;
border-width: 1px;
padding: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  border-right: 1px solid #e5e7eb;

  &:last-child {
    border-right: none;
  }
`

const Cells = styled.div`
  padding: 10px;
  border-right: 1px solid #e5e7eb;

  display: flex;
  align-items: center; 
  text-align: left;

  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;

  &:last-child {
    border-right: none;
  }
`


const HeaderCell = styled.div`
width: 200;
height: 43;
gap: 10px;
angle: 0 deg;
opacity: 1;
border-width: 1px;
padding: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  border-right: 1px solid #e5e7eb;

  &:last-child {
    border-right: none;
  }
`

const TableHeaders = styled.div`
width: 800;
height: 43;
angle: 0 deg;
opacity: 1;

  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
`

const TableRows = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  border-bottom: 1px solid #e5e7eb;

  &:last-child {
    border-bottom: none;
  }
`

const Link = styled.span`
  color: #3249d7;
  cursor: pointer;
`

const ActionGroup = styled.div`
  display: flex;
  gap: 8px;
`

const FooterWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

const ApproveAllButton = styled.button`
  width: 118px;
  height: 42px;
  border-radius: 10px;
  padding: 6px 15px;
  background: #3249d7;
  color: #fff;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background: #2b3fc4;
  }
`

const ApproveButton = styled.button`
  width: 79px;
  height: 32px;
  padding: 6px 10px;
  border-radius: 10px;
  background: #3249d7;
  color: #ffffff;
  border: none;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    background: #2b3fc4;
  }
`

const RejectButton = styled.button`
  width: 64px;
  height: 32px;
  padding: 6px 10px;
  border-radius: 10px;
  background: #fbfaff;
  color: #2b3fc4;
  border: 1px solid #e5e7eb;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    background: #f0efff;
  }
`

const ApprovedButton = styled.button`
  width: 175px;
  height: 32px;
  padding: 6px 10px;
  border-radius: 10px;
  background: #caeee1;
  color: #065f46; /* dark green text for contrast */
  border: none;
  font-size: 12px;
  font-weight: 500;
  cursor: default;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`

const RejectedButton = styled.button`
  width: 175px;
  height: 32px;
  padding: 6px 10px;
  border-radius: 10px;
  background: #f6c8c9;
  color: #7f1d1d; /* dark red text for contrast */
  border: none;
  font-size: 12px;
  font-weight: 500;
  cursor: default;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`

const AfterStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-start;
`

const AfterTitle = styled.div`
width: 99;
height: 20;
angle: 0 deg;
opacity: 1;
color: #000000;
font-family: Plus Jakarta Sans;
font-weight: 400;
font-style: Regular;
font-size: 14px;
leading-trim: NONE;
line-height: 20px;
letter-spacing: 0%;

`

const AfterDuration = styled.div`
width: 134;
height: 20;
angle: 0 deg;
opacity: 1;

color: #000000;
font-family: Plus Jakarta Sans;
font-weight: 400;
font-style: Regular;
font-size: 14px;
leading-trim: NONE;
line-height: 20px;
letter-spacing: 0%;
`

const AfterHeading = styled.div`
font-family: Plus Jakarta Sans;
font-weight: 500;
font-style: Medium;
font-size: 12px;
leading-trim: NONE;
line-height: 100%;
letter-spacing: 0%;
vertical-align: middle;
width: 51;
height: 15;
angle: 0 deg;
opacity: 1;
  color: #676e83;
`

const AfterValue = styled.div`
font-family: Plus Jakarta Sans;
font-weight: 400;
font-style: Regular;
font-size: 14px;
leading-trim: NONE;
line-height: 20px;
letter-spacing: 0%;
width: 76;
height: 20;
angle: 0 deg;
opacity: 1;
  color: #000000;
`

const RightMeta = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;  /* push content to the right */
  text-align: right;
`

const SuccessPopup = styled.div`
  width: 763px;
  height: 405px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0px 1px 2px 0px #1018280D;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
`

const SuccessIcon = styled.div`
  width: 80px;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateX(8px);
`

const SuccessText = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  text-align: center;
  width: 78px;
  height: 21px;
  color: #343E59;
`

const SuccessCloseButton = styled.button`
width: 80;
height: 38;
angle: 0 deg;
opacity: 1;
top: 252px;
left: 341px;
gap: 7px;
border-radius: 10px;
padding-top: 9px;
padding-right: 20px;
padding-bottom: 9px;
padding-left: 20px;
background: #FBFAFF;
color: #3249D7;

border: 1px solid #E3DEFF
`

const DescriptionText = styled.span`
  font-family: Plus Jakarta Sans;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #000;
`

export default function ApprovalDrawer({ open, onClose, record, onRefresh }) {
  if (!record) return null

  const studentId = record?.studentId || record?.key
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [modalContent, setModalContent] = useState({
    image: '',
    text: '',
    actionType: '',
    req: null,
  })
  const [rejectionReason, setRejectionReason] = useState('')
  const [showSuccess, setShowSuccess] = useState(false)
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewResume, setPreviewResume] = useState(null)
  const [actionLoading, setActionLoading] = useState(false)
  const [requests, setRequests] = useState([])
  const [loading, setLoading] = useState(false)
  const [expandedDescriptions, setExpandedDescriptions] = useState({})

  const FIELD_LABEL_MAP = {
    // Personal
    cv: 'Resume',
    firstName: 'First Name',
    lastName: 'Last Name',
    dob: 'Date of Birth',
    gender: 'Gender',
    primaryEmail: 'Primary Email',
    phoneNumber: 'Mobile Number',

    // Permanent Address
    permCountry: 'Permanent Country',
    permState: 'Permanent State',
    permCity: 'Permanent City',
    permPostCode: 'Permanent Pincode',

    // Current Address
    corrCountry: 'Current Country',
    corrState: 'Current State',
    corrCity: 'Current City',
    corrPostCode: 'Current Pincode',

    // 10th Education
    'tenth.board': '10th Board',
    'tenth.endYear': '10th Year of Passing',
    'tenth.marks': '10th Marks (%)',
    'tenth.markSheetUrl': '10th Marksheet',

    // 12th Education
    'twelfth.board': '12th Board',
    'twelfth.endYear': '12th Year of Passing',
    'twelfth.marks': '12th Marks (%)',
    'twelfth.markSheetUrl': '12th Marksheet',

    // Other Education
    'otherEducation.state': 'College State',
    'otherEducation.city': 'College City',
    'otherEducation.collegeName': 'College Name',
    'otherEducation.university': 'University Name',
    'otherEducation.degree': 'Degree',
    'otherEducation.department': 'Department',
    'otherEducation.specialisation': 'Specialisation',
    'otherEducation.endYear': 'Year of Passing',
    'otherEducation.marks': 'Marks (%)',
    'otherEducation.markSheetUrl': 'Other Education Marksheet',

    // Current Course
    'currentCourse.state': 'Current Course State',
    'currentCourse.city': 'Current Course City',
    'currentCourse.collegeName': 'Current Course College Name',
    'currentCourse.university': 'Current Course University',
    'currentCourse.degree': 'Current Course Degree',
    'currentCourse.department': 'Current Course Department',
    'currentCourse.specialisation': 'Current Course Specialisation',
    'currentCourse.endYear': 'Current Course Year of Passing',
    'currentCourse.marks': 'Current Course Marks (%)',
    'currentCourse.averageMarks': 'Current Course Marks (%)',
    'currentCourse.historyOfArrears': 'Current Course History of Arrears',
    'currentCourse.noOfArrears': 'Current Course Current Arrears',
    'currentCourse.markSheetUrl': 'Current Course Marksheet',

    // Projects
    'projects.title': 'Project Title',
    'projects.started_in': 'Project Start Date',
    'projects.ended_in': 'Project End Date',
    'projects.description': 'Project Description',
    'projects.certifications': 'Project Certificate',
    'projects.addNew': 'New Project',

    // Internships
    'internships.companyName': 'Company Name',
    'internships.started_in': 'Internship Start Date',
    'internships.ended_in': 'Internship End Date',
    'internships.function': 'Function',
    'internships.role': 'Role',
    'internships.industry': 'Industry',
    'internships.description': 'Internship Description',
    'internships.certifications': 'Internship Certificate',
    'internships.addNew': 'New Internship',

    // Work Experience
    'workExperience.companyName': 'Company Name',
    'workExperience.started_in': 'Work Experience Start Date',
    'workExperience.ended_in': 'Work Experience End Date',
    'workExperience.function': 'Function',
    'workExperience.role': 'Role',
    'workExperience.industry': 'Industry',
    'workExperience.description': 'Work Experience Description',
    'workExperience.certifications': 'Work Experience Certificate',
    'workExperience.addNew': 'New Work Experience',

    // Certifications
    'certifications.organisation': 'Institute Name',
    'certifications.title': 'Course Name',
    'certifications.started_in': 'Certification Start Date',
    'certifications.ended_in': 'Certification End Date',
    'certifications.description': 'Certification Description',
    'certifications.certificate': ' Course Certificate',
    'certifications.addNew': 'New Certification',

    // Extra Curricular
    extraCurriculars: 'Extra Curricular Activity',

    //New Fields
    workExperience: 'Work Experience',
    internships: 'Internship',
    projects: 'Project',
    certifications: 'Certification',
    extraCurriculars: 'Extra Curricular Activity',
    tenth: '10th Education',
    twelfth: '12th Education',
    otherEducation: 'Other Education',
    certifications: 'Certification',
  }

  const EDUCATION_LEVEL_LABEL_MAP = {
    diploma: 'Diploma Education',
    ug: 'Undergraduate Education',
    pg: 'Postgraduate Education',
    phd: 'PhD Education',
    other: 'Other Education',
    p_g_diploma: 'Postgraduate Diploma Education',
  }

  const renderExpandableDescription = (text, reqId) => {
  if (!text) return 'NA'

  const clean = stripHtml(text)
  const expanded = expandedDescriptions[reqId]

  const displayText = truncateToTwoLines(clean, expanded, 100)

  return (
    <AfterValue style={{ display: 'inline' }}>
      {displayText}

      {clean.length > 100 && (
        <span
          onClick={() => toggleDescription(reqId)}
          style={{
            color: '#3249D7',
            cursor: 'pointer',
            marginLeft: 4,
            fontWeight: 500,
            display: 'inline',
          }}
        >
          {expanded ? '...less' : '...more'}
        </span>
      )}
    </AfterValue>
  )
}

  const approveRequestDirect = async (req) => {
    if (actionLoading) return

    setActionLoading(true)

    try {
      let res

      if (req.isGrouped) {
        const ids = req.requests.map(r => r.id || r.requestId)

        res = await dispatch(
          bulkApproveApprovalRequests({ requestIds: ids })
        )
      } else {
        res = await dispatch(
          approveApprovalRequest(req.id || req.requestId)
        )
      }

      if (res) {
        SuccessMessage('Approved successfully')   // ✅ snackbar
        dispatch(studentsMetricsData())
        dispatch(getTPOMetrics())

        await fetchRequests()   // refresh table
      }

    } catch (err) {
      console.error(err)
    }

    setActionLoading(false)
  }

  const toggleDescription = id => {
    setExpandedDescriptions(prev => ({
      ...prev,
      [id]: !prev[id],
    }))
  }

  const truncateToTwoLines = (text, expanded, limit = 100) => {
    if (!text) return ''

    const clean = stripHtml(text)

    if (expanded || clean.length <= limit) return clean

    const trimmed = clean.substring(0, limit)

    // cut at last full word
    return trimmed.substring(0, trimmed.lastIndexOf(' '))
  }

  const getFieldLabel = req => {
    if (!req) return ''

    const fieldName = req.fieldName

    // ✅ Handle Other Education dynamically
    if (fieldName === 'otherEducation') {
      const level = req?.requestedData?.educationLevel

      const levelLabel =
        EDUCATION_LEVEL_LABEL_MAP[level] || 'Other Education'

      return levelLabel
    }

    return FIELD_LABEL_MAP[fieldName] || fieldName
  }

  const PERM_FIELDS = [
    'permCountry',
    'permState',
    'permCity',
    'permPostCode',
  ]
  const CORR_FIELDS = [
    'corrCountry',
    'corrState',
    'corrCity',
    'corrPostCode',
  ]

  const dispatch = useDispatch()
  const formatMonth = value => {
    if (!value) return ''
    const [mm, yyyy] = value.split('/')
    const date = new Date(`${yyyy}-${mm}-01`)
    return date.toLocaleString('en-US', { month: 'short', year: 'numeric' })
  }
  const handleApproveClick = req => {
    if (req.isGrouped) {
      setModalContent({
        image: 'approveImage',
        text: `Are you sure to accept approve for this field?`,//all ${req.fieldName} changes?`,
        actionType: 'approve-group',
        req,
      })
    } else {
      setModalContent({
        image: 'approveImage',
        text: `Are you sure to accept approval for this field?`,
        actionType: 'approve',
        req,
      })
    }
  }


  const handleRejectClick = req => {
    if (req.isGrouped) {
      setModalContent({
        image: 'rejectImage',
        text: `Are you sure to reject all ${req.fieldName} changes?`,
        actionType: 'reject-group',
        req,
      })
    } else {
      setModalContent({
        image: 'rejectImage',
        text: `Are you sure to reject "${req.fieldName}" this verification from the candidate?`,
        actionType: 'reject',
        req,
      })
    }
    setIsModalVisible(true)
  }


  const handleCloseModal = () => {
    setIsModalVisible(false)
    setModalContent({ image: '', text: '', actionType: '', req: null })
    setRejectionReason('')
  }

  const handleConfirmAction = async () => {
    if (!modalContent.req || actionLoading) return

    setActionLoading(true)

    if (modalContent.actionType === 'approve-group') {
      setLoading(true)

      const ids = modalContent.req.requests.map(
        r => r.id || r.requestId
      )

      const res = await dispatch(
        bulkApproveApprovalRequests({ requestIds: ids })
      )

      if (res) {
        const emailTemplate = ReactDOMServer.renderToString(
          <ProfileApprovalTemplate data={{
            studentName: record.name,
            approvedDetails: [{
              section: modalContent.req.fieldName, // Permanent Address / Current Address
              fields: 'Updated'
            }],
            signatureName: 'Placement Team'
          }} />
        )

        await dispatch(sendNotificationBulkEmail([{
          to: record.email,
          subject: 'Profile Update Approved – Details Updated',
          htmlBody: emailTemplate,
        }]))
      }

      await fetchRequests()
      dispatch(studentsMetricsData())
      dispatch(getTPOMetrics())
      setLoading(false)
    }


    if (modalContent.actionType === 'reject-group') {

      setLoading(true)

      await Promise.all(
        modalContent.req.requests.map(r =>
          dispatch(
            rejectApprovalRequest(r.id || r.requestId, {
              rejectionReason,
            })
          )
        )
      )

      const emailTemplate = ReactDOMServer.renderToString(
        <ProfileRejectedTemplate data={{
          studentName: record.name,
          rejectedDetails: [{
            section: modalContent.req.fieldName, // Permanent / Current Address
            fields: 'Updated',
            reason: rejectionReason
          }],
          signatureName: 'Placement Team'
        }} />
      )

      await dispatch(sendNotificationBulkEmail([{
        to: record.email,
        subject: 'Profile Update Rejected – Details Provided',
        htmlBody: emailTemplate,
      }]))

      await fetchRequests()
      dispatch(studentsMetricsData())
      dispatch(getTPOMetrics())
      setLoading(false)
    }


    if (modalContent.actionType === 'approve') {
      setLoading(true)
      const res = await dispatch(
        approveApprovalRequest(modalContent.req.id || modalContent.req.requestId)
      )
      if (res?.status === 'APPROVED') {
        const emailTemplate = ReactDOMServer.renderToString(
          <ProfileApprovalTemplate data={{
            studentName: record.name,
            approvedDetails: [{
              section: modalContent.req.fieldName,
              fields: modalContent.req.isNewItem ? 'New Entry' : 'Updated'
            }],
            signatureName: 'Placement Team'
          }} />
        )

        await dispatch(sendNotificationBulkEmail([{
          to: record.email,
          subject: 'Profile Update Approved – Details Updated',
          htmlBody: emailTemplate,
        }]))

        await fetchRequests()
      }
      setLoading(false)
    }

    if (modalContent.actionType === 'reject') {

      setLoading(true)

      const res = await dispatch(
        rejectApprovalRequest(
          modalContent.req.id || modalContent.req.requestId,
          { rejectionReason }
        )
      )

      if (res?.status === 'REJECTED') {
        const emailTemplate = ReactDOMServer.renderToString(
          <ProfileRejectedTemplate data={{
            studentName: record.name,
            rejectedDetails: [{
              section: modalContent.req.fieldName,
              fields: modalContent.req.isNewItem ? 'New Entry' : 'Updated',
              reason: rejectionReason
            }],
            signatureName: 'Placement Team'
          }} />
        )

        await dispatch(sendNotificationBulkEmail([{
          to: record.email,
          subject: 'Profile Update Rejected – Details Provided',
          htmlBody: emailTemplate,
        }]))

        await fetchRequests()
        dispatch(studentsMetricsData())
        dispatch(getTPOMetrics())
      }

      setLoading(false)
    }
    if (modalContent.actionType === 'approve-all') {
      setLoading(true)

      const ids = modalContent.req.map(r => r.id || r.requestId)

      const res = await dispatch(
        bulkApproveApprovalRequests({ requestIds: ids })
      )

      if (res) {
        const approvedDetails = modalContent.req.map(req => ({
          section: req.fieldName,
          fields: req.isNewItem ? 'New Entry' : 'Updated'
        }))

        const emailTemplate = ReactDOMServer.renderToString(
          <ProfileApprovalTemplate data={{
            studentName: record.name,
            approvedDetails: approvedDetails,
            signatureName: 'Placement Team'
          }} />
        )

        await dispatch(sendNotificationBulkEmail([{
          to: record.email,
          subject: 'Profile Update Approved – Details Updated',
          htmlBody: emailTemplate,
        }]))

        await fetchRequests()
        dispatch(studentsMetricsData())
        dispatch(getTPOMetrics())
        await onClose?.()
        onRefresh?.()
      }

      setLoading(false)
    }
    setActionLoading(false)
    handleCloseModal()
  }
  const formatTimestampToMMMYYYY = timestamp => {
    if (!timestamp) return ''

    const date = new Date(timestamp)

    return date.toLocaleString('en-US', {
      month: 'short',
      year: 'numeric',
    })
  }
  const FILE_FIELDS = [
    'tenth.markSheetUrl',
    'twelfth.markSheetUrl',
    'otherEducation.markSheetUrl',
    'projects.certifications',
    'internships.certifications',
    'workExperience.certifications',
    'certifications.certificate',
    'currentCourse.markSheetUrl',
    'education.markSheetUrl',
  ]

  const fetchRequests = async () => {
    try {
      setLoading(true)
      const res = await dispatch(getApprovalRequests(studentId))
      console.log('Approval API raw response:', res)

      const list = res?.data?.requests || res?.requests || res || []

      console.log('Parsed approval list:', list)
      setRequests(list)
      if (!list || list.length === 0) {
        onClose?.()
        onRefresh?.()
      }
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (open && studentId) fetchRequests()
  }, [open, studentId])
  const studentRequests = requests.filter(
    r => r.studentId === studentId
  )
  console.log('record.studentId:', record?.studentId)
  console.log('all requests:', requests)
  console.log(
    'filtered studentRequests:',
    requests.filter(r => r.studentId === record?.key)
  )
  console.log('record object:', record)

  const permRequests = studentRequests.filter(r =>
    PERM_FIELDS.includes(r.fieldName) && r.approvalType === 'ALWAYS'
  )

  const nonPermRequests = studentRequests.filter(
    r => !PERM_FIELDS.includes(r.fieldName) && r.approvalType === 'ALWAYS'
  )

  const hasMeaningfulValue = val => {
    if (!val) return false
    if (typeof val === 'string') return val.trim() !== ''
    if (typeof val === 'object') {
      return Object.values(val).some(
        v => typeof v === 'string' && v.trim() !== ''
      )
    }
    return false
  }

  const buildDurationGroups = (requests, baseName, label) => {
    const map = {}

    requests.forEach(r => {
      if (
        r.fieldName === `${baseName}.started_in` ||
        r.fieldName === `${baseName}.ended_in`
      ) {
        const key = r.itemId

        if (!map[key]) {
          map[key] = { started: null, ended: null, requests: [] }
        }

        if (r.fieldName.includes('started')) map[key].started = r
        if (r.fieldName.includes('ended')) map[key].ended = r

        map[key].requests.push(r)
      }
    })

    return Object.values(map)
      .filter(g =>
        g.started &&
        g.ended &&
        hasMeaningfulValue(g.started.requestedData) &&
        hasMeaningfulValue(g.ended.requestedData)
      )
      .map(g => ({
        id: `${baseName}-${g.started.id}`,
        isGrouped: true,
        isDurationGroup: true,
        fieldName: label,
        started: g.started,
        ended: g.ended,
        requests: g.requests,
        status: g.requests.every(r => r.status === 'APPROVED')
          ? 'APPROVED'
          : g.requests.every(r => r.status === 'REJECTED')
            ? 'REJECTED'
            : 'PENDING',
      }))
  }
  const alwaysRequests = studentRequests.filter(
    r => r.approvalType === 'ALWAYS'
  )
  const workExpDurationGroups = buildDurationGroups(
    alwaysRequests,
    'workExperience',
    'Work Experience Duration'
  )

  const internshipDurationGroups = buildDurationGroups(
    alwaysRequests,
    'internships',
    'Internship Duration'
  )

  const projectDurationGroups = buildDurationGroups(
    alwaysRequests,
    'projects',
    'Project Duration'
  )

  const certificateDurationGroups = buildDurationGroups(
    alwaysRequests,
    'certifications',
    'Certificate Duration'
  )

  const permGroupRow =
    permRequests.length > 0
      ? {
        id: 'perm-group',
        isGrouped: true,
        fieldName: 'Permanent Address',
        requests: permRequests,
        status: permRequests.every(r => r.status === 'APPROVED')
          ? 'APPROVED'
          : permRequests.every(r => r.status === 'REJECTED')
            ? 'REJECTED'
            : 'PENDING',
      }
      : null

  const corrRequests = studentRequests.filter(r =>
    CORR_FIELDS.includes(r.fieldName) && r.approvalType === 'ALWAYS'
  )

  const DURATION_FIELDS = [
    'workExperience.started_in',
    'workExperience.ended_in',
    'internships.started_in',
    'internships.ended_in',
    'projects.started_in',
    'projects.ended_in',
    'certifications.started_in',
    'certifications.ended_in',
  ]

  const groupedDurationIds = new Set(
    [
      ...workExpDurationGroups,
      ...internshipDurationGroups,
      ...projectDurationGroups,
      ...certificateDurationGroups,
    ].flatMap(g => g.requests.map(r => r.id))
  )

  const nonAddressRequests = studentRequests.filter(r =>
    !PERM_FIELDS.includes(r.fieldName) &&
    !CORR_FIELDS.includes(r.fieldName) &&
    (
      !DURATION_FIELDS.includes(r.fieldName) ||
      !groupedDurationIds.has(r.id)
    )
  )


  const corrGroupRow =
    corrRequests.length > 0
      ? {
        id: 'corr-group',
        isGrouped: true,
        fieldName: 'Current Address',
        requests: corrRequests,
        status: corrRequests.every(r => r.status === 'APPROVED')
          ? 'APPROVED'
          : corrRequests.every(r => r.status === 'REJECTED')
            ? 'REJECTED'
            : 'PENDING',
      }
      : null
  const extractValue = val => {
    if (!val) return ''
    if (typeof val === 'object') return Object.values(val)[0] || ''
    return val
  }

  const formatCorrAddress = (list, key) => {
    const map = {}

    list.forEach(r => {
      map[r.fieldName] = extractValue(r[key])
    })

    // If country is empty → show NA
    // if (!map.corrCountry) return 'NA'

    const value = [
      map.corrCity,
      map.corrState,
      map.corrCountry,
      map.corrPostCode,
    ]
      .filter(Boolean)
      .join(', ')

    return value || 'NA'
  }

  const formatNameGroup = (list, key) => {
    const map = {}

    list.forEach(r => {
      map[r.fieldName] = extractValue(r[key])
    })

    return [map.firstName, map.lastName].filter(Boolean).join(' ')
  }

  const formatPermAddress = (list, key) => {
    const map = {}

    list.forEach(r => {
      map[r.fieldName] = extractValue(r[key])
    })

    // If country is empty → show NA
    // if (!map.permCountry) return 'NA'

    const value = [
      map.permCity,
      map.permState,
      map.permCountry,
      map.permPostCode,
    ]
      .filter(Boolean)
      .join(', ')
    return value || 'NA'
  }

  const renderValue = value => {
    if (value === null || value === undefined) return 'NA'

    if (Array.isArray(value)) {
      if (!value.length) return 'NA'
      return value.map(v =>
        typeof v === 'object' ? JSON.stringify(v) : String(v)
      ).join(', ')
    }

    if (typeof value === 'object') {
      return Object.entries(value).map(([k, v]) => (
        <div key={k}>
          <strong>{k}:</strong> {renderValue(v)}
        </div>
      ))
    }

    return String(value)
  }
  const renderFileValue = data => {
    if (!data || typeof data !== 'object') return 'NA'

    const url = data.url
    if (!url) return 'NA'

    return (
      <Link
        onClick={() => window.open(url, '_blank')}
      >
        <AfterTitle style={{ color: '#3249D7' }}>
          {data.name || 'View File'}
        </AfterTitle>
      </Link>
    )
  }

  const oneTimeRequests = studentRequests.filter(
    r => r.approvalType === 'ONE_TIME'
  )
  const permOneTime = oneTimeRequests.filter(r =>
    PERM_FIELDS.includes(r.fieldName)
  )

  const corrOneTime = oneTimeRequests.filter(r =>
    CORR_FIELDS.includes(r.fieldName)
  )

  const otherOneTime = oneTimeRequests.filter(r =>
    !PERM_FIELDS.includes(r.fieldName) &&
    !CORR_FIELDS.includes(r.fieldName) &&
    (
      !DURATION_FIELDS.includes(r.fieldName) ||
      !groupedDurationIds.has(r.id)
    )
  )
  const permOneTimeGroup =
    permOneTime.length > 0
      ? {
        id: 'perm-one-time-group',
        isGrouped: true,
        fieldName: 'Permanent Address',
        requests: permOneTime,
        status: permOneTime.every(r => r.status === 'APPROVED')
          ? 'APPROVED'
          : permOneTime.every(r => r.status === 'REJECTED')
            ? 'REJECTED'
            : 'PENDING',
      }
      : null

  const corrOneTimeGroup =
    corrOneTime.length > 0
      ? {
        id: 'corr-one-time-group',
        isGrouped: true,
        fieldName: 'Current Address',
        requests: corrOneTime,
        status: corrOneTime.every(r => r.status === 'APPROVED')
          ? 'APPROVED'
          : corrOneTime.every(r => r.status === 'REJECTED')
            ? 'REJECTED'
            : 'PENDING',
      }
      : null
  const oneTimeTableData = [
    ...(permOneTimeGroup ? [permOneTimeGroup] : []),
    ...(corrOneTimeGroup ? [corrOneTimeGroup] : []),

    ...buildDurationGroups(oneTimeRequests, 'workExperience', 'Work Experience Duration'),
    ...buildDurationGroups(oneTimeRequests, 'internships', 'Internship Duration'),
    ...buildDurationGroups(oneTimeRequests, 'projects', 'Project Duration'),
    ...buildDurationGroups(oneTimeRequests, 'certifications', 'Certificate Duration'),

    ...otherOneTime,
  ]

  const renderOneTimeValue = (data, reqId) => {
    if (data === null || data === undefined) return 'NA'

    const endedOnFormatted = data?.endedOn
      ? new Date(data.endedOn).getFullYear()
      : null

    // Resume Upload
    if (data?.fileUrl && data?.resumeName) {
      return (
        <Link
          onClick={() =>
            window.open(
              typeof data.fileUrl === 'string'
                ? data.fileUrl
                : data.fileUrl?.url,
              '_blank'
            )
          }
        >
          <AfterTitle style={{ color: '#3249D7' }}>
            {data.resumeName}
          </AfterTitle>
        </Link>
      )
    }

    // Structured Object Rendering (projects, internships, experience, certifications, etc)
    if (typeof data === 'object') {
      return (
        <AfterStack>

          {data?.title && (
            <>
              <AfterHeading>Title</AfterHeading>
              <AfterValue>{data?.title}</AfterValue>
            </>
          )}

          {data?.role && (
            <>
              <AfterHeading>Role</AfterHeading>
              <AfterValue>{data?.role}</AfterValue>
            </>
          )}

          {(data.started_in || data.ended_in) && (
            <>
              <AfterHeading>Duration</AfterHeading>
              <AfterDuration>
                {formatMonth(data.started_in)} - {formatMonth(data.ended_in)}
              </AfterDuration>
            </>
          )}

          {Array.isArray(data.skill_set) && data.skill_set.length > 0 && (
            <>
              <AfterHeading>Skills</AfterHeading>
              {data.skill_set.map(s => (
                <AfterValue key={s.id}>{s.name}</AfterValue>
              ))}
            </>
          )}

          {data?.jobType && (
            <>
              <AfterHeading>Job Type</AfterHeading>
              <AfterValue>{data?.jobType}</AfterValue>
            </>
          )}

          {data?.organization && (
            <>
              <AfterHeading>Organization</AfterHeading>
              <AfterValue>{data?.organization}</AfterValue>
            </>
          )}

          {data?.function && (
            <>
              <AfterHeading>Function</AfterHeading>
              <AfterValue>{data?.function}</AfterValue>
            </>
          )}

          {data?.industry && (
            <>
              <AfterHeading>Industry</AfterHeading>
              <AfterValue>{data?.industry}</AfterValue>
            </>
          )}

          {Array.isArray(data?.awards) && data?.awards.length > 0 && (
            <>
              <AfterHeading>Awards</AfterHeading>
              {data?.awards.map((a, i) => (
                <AfterValue key={i}>{a}</AfterValue>
              ))}
            </>
          )}

          {data.description && (
            <>
              <AfterHeading>Description</AfterHeading>

              {renderExpandableDescription(data.description, reqId)}
            </>
          )}

          {data.institutionName && (
            <>
              <AfterHeading>Institution Name</AfterHeading>
              <AfterValue>{data.institutionName}</AfterValue>
            </>
          )}

          {data?.university && (
            <>
              <AfterHeading>University</AfterHeading>
              <AfterValue>{data?.university}</AfterValue>
            </>
          )}

          {/* {data.domain && (
          <>
            <AfterHeading>Domain</AfterHeading>
            <AfterValue>{data.domain}</AfterValue>
          </>
        )} */}

          {data.state && (
            <>
              <AfterHeading>State</AfterHeading>
              <AfterValue>{data.state}</AfterValue>
            </>
          )}

          {data.city && (
            <>
              <AfterHeading>City</AfterHeading>
              <AfterValue>{data.city}</AfterValue>
            </>
          )}

          {data.degree && (
            <>
              <AfterHeading>Degree</AfterHeading>
              <AfterValue>{data.degree}</AfterValue>
            </>
          )}

          {data.department && (
            <>
              <AfterHeading>Department</AfterHeading>
              <AfterValue>{data.department}</AfterValue>
            </>
          )}

          {data.specialisation && (
            <>
              <AfterHeading>Specialisation</AfterHeading>
              <AfterValue>{data.specialisation}</AfterValue>
            </>
          )}

          {data.board && (
            <>
              <AfterHeading>Board</AfterHeading>
              <AfterValue>{data.board}</AfterValue>
            </>
          )}

          {endedOnFormatted && (
            <>
              <AfterHeading>Year Of Passing</AfterHeading>
              <AfterDuration>{endedOnFormatted}</AfterDuration>
            </>
          )}

          {data.marks && (
            <>
              <AfterHeading>Marks</AfterHeading>
              <AfterValue>{data.marks}</AfterValue>
            </>
          )}

          {Array.isArray(data.skills) && data.skills.length > 0 && (
            <>
              <AfterHeading>Skills</AfterHeading>
              {data.skills.map(s => (
                <AfterValue key={s.id}>{s.name}</AfterValue>
              ))}
            </>
          )}

          {typeof data.historyOfArrears === 'number' &&
            data.historyOfArrears > 0 && (
              <>
                <AfterHeading>History Of Arrears</AfterHeading>
                <AfterValue>{data.historyOfArrears}</AfterValue>
              </>
            )}

          {data.markSheetUrl?.url && (
            <>
              <AfterHeading>MarkSheet</AfterHeading>
              <Link
                onClick={() => window.open(data.markSheetUrl.url, '_blank')}
              >
                <AfterValue style={{ color: '#3249D7', cursor: 'pointer' }}>
                  {data.markSheetUrl.name || 'View Marksheet'}
                </AfterValue>
              </Link>
            </>
          )}

          {data.certificate?.url && (
            <>
              <AfterHeading>Certificate</AfterHeading>
              <Link
                onClick={() => window.open(data.certificate.url, '_blank')}
              >
                <AfterValue style={{ color: '#3249D7', cursor: 'pointer' }}>
                  {data.certificate.name || 'View Certificate'}
                </AfterValue>
              </Link>
            </>
          )}
        </AfterStack>
      )
    }

    // Primitive Values (phone, dob, etc)
    return renderExpandableDescription(String(data), reqId)
  }

  const visibleRequests = [
    ...(permGroupRow ? [permGroupRow] : []),
    ...(corrGroupRow ? [corrGroupRow] : []),

    ...workExpDurationGroups,
    ...internshipDurationGroups,
    ...projectDurationGroups,
    ...certificateDurationGroups,

    ...nonAddressRequests.filter(r => r.approvalType === 'ALWAYS'),
  ]
  const showOneTimeTable = Array.isArray(oneTimeRequests) && oneTimeRequests.length > 0
  const showOtherVerificationTable = Array.isArray(visibleRequests) && visibleRequests.length > 0

  const totalApproveCount =
    oneTimeRequests.length + visibleRequests.length
  const stripHtml = html => {
    if (!html) return 'NA'

    const div = document.createElement('div')
    div.innerHTML = html

    const text = (div.textContent || div.innerText || '').trim()

    return text ? text : 'NA'
  }

  const isSimpleKeyValueObject = obj => {
    if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return false

    const keys = Object.keys(obj).filter(k => obj[k] !== '' && obj[k] !== null)

    return keys.length === 1
  }

  const formatYearOnly = val => {
    if (!val) return 'NA'
    const num = Number(val)
    if (isNaN(num)) return 'NA'
    return new Date(num).getFullYear()
  }

  const YEAR_FIELDS = [
    'tenth.endYear',
    'twelfth.endYear',
    'otherEducation.endYear',
  ]

  const navigate = useNavigate()

  return (
    <Drawer
      open={open}
      onClose={() => {
        onClose?.()
        onRefresh?.()
      }}
      loading={loading}
      closable
      title="Profile Update Details"
      width="80%"
      footer={
        <FooterWrapper>
          <ApproveAllButton
            onClick={() => {
              if (actionLoading) return
              setModalContent({
                image: 'approveImage',
                text: `Are you sure you want to approve all ${totalApproveCount} requests?`,

                actionType: 'approve-all',
                req: studentRequests.filter(r => r.status === 'PENDING'),
              }) || setIsModalVisible(true)
            }}
          >
            Approve All
          </ApproveAllButton>
        </FooterWrapper>
      }
      content={
        <Spin spinning={loading} tip="Loading...">
          <Wrapper style={{ opacity: loading ? 0.5 : 1 }}>
            {/* User Header */}
            <HeaderRow>
              <UserRow>
                <Avatar size={48}>{record.name?.[0]}</Avatar>
                <div>
                  <Name style={{ color: "#3249d7" }}>
                    <div
                      style={{ color: '#3249d7', fontWeight: 500, cursor: 'pointer' }}
                      onClick={() => navigate(`/tpoApproval/student-resume/${record.key}`)}
                    >
                      {record.name}
                    </div>
                  </Name>
                  <Meta>{record.roll}</Meta>
                </div>
              </UserRow>
              <RightMeta>
                <Meta>{record.phone}</Meta>
                <Meta>{record.email}</Meta>
              </RightMeta>
            </HeaderRow>
            {showOneTimeTable && (
              <>
                {/* One-time verifications */}
                <SectionTitle>One time verifications</SectionTitle>

                <Table>
                  <TableHeader>
                    <HeaderCell>FIELD NAME</HeaderCell>
                    <HeaderCell>CHANGE REQUESTED</HeaderCell>
                    <HeaderCell>ACTION</HeaderCell>
                  </TableHeader>


                  {oneTimeTableData.map(req => {
                    const renderAction = () => {
                      if (req.status === 'APPROVED') return <ApprovedButton>Approved</ApprovedButton>
                      if (req.status === 'REJECTED') return <RejectedButton>Rejected</RejectedButton>

                      return (
                        <ActionGroup>
                          <ApproveButton onClick={() => {
                            approveRequestDirect(req)
                          }}>Approve</ApproveButton>
                          <RejectButton onClick={() => {
                            if (actionLoading) return
                            handleRejectClick(req)
                          }}>Reject</RejectButton>
                        </ActionGroup>
                      )
                    }

                    return (
                      <TableRow key={req.id}>
                        <Cell>
                          {req.isNewItem
                            ? `New ${getFieldLabel(req)}`
                            : getFieldLabel(req)}
                        </Cell>
                        <Cell>
                          {req.isDurationGroup
                            ? `${formatMonth(req.started.requestedData)} - ${formatMonth(req.ended.requestedData)}`
                            : req.isGrouped
                              ? req.fieldName === 'Permanent Address'
                                ? formatPermAddress(req.requests, 'requestedData')
                                : formatCorrAddress(req.requests, 'requestedData')
                              : FILE_FIELDS.includes(req.fieldName)
                                ? renderFileValue(req.requestedData?.markSheetUrl || req.requestedData)
                                : req.isNewItem
                                  ? renderOneTimeValue(req.requestedData, `${req.id}-change`)
                                  : isSimpleKeyValueObject(req.requestedData)
                                    ? extractValue(req.requestedData) || 'NA'
                                    : typeof req.requestedData === 'object'
                                      ? extractValue(req.requestedData) || renderOneTimeValue(req.requestedData, `${req.id}-change`)
                                      : YEAR_FIELDS.includes(req.fieldName)
                                        ? formatYearOnly(req.requestedData)
                                        : renderOneTimeValue(req.requestedData, `${req.id}-change`)}

                        </Cell>
                        <Cell>{renderAction()}</Cell>
                      </TableRow>
                    )
                  })}

                </Table>
              </>
            )}
            {showOtherVerificationTable && (
              <>

                {/* Other Verification */}
                <SectionTitle>Other Verification</SectionTitle>

                <Table>
                  <TableHeaders>
                    <HeaderCells>FIELD NAME</HeaderCells>
                    <HeaderCells>BEFORE</HeaderCells>
                    <HeaderCells>AFTER</HeaderCells>
                    <HeaderCells>ACTION</HeaderCells>
                  </TableHeaders>

                  {[
                    ...(permGroupRow ? [permGroupRow] : []),
                    ...(corrGroupRow ? [corrGroupRow] : []),
                    ...workExpDurationGroups,
                    ...internshipDurationGroups,
                    ...projectDurationGroups,
                    ...certificateDurationGroups,
                    ...nonAddressRequests.filter(r => r.approvalType === 'ALWAYS'),
                  ].map(req => {
                    const fieldLabel = req.isGrouped
                      ? req.fieldName
                      : req.isNewItem
                        ? `New ${req.fieldName}`
                        : req.fieldName

                    const beforeValue = req.isDurationGroup
                      ? `${formatMonth(req.started.originalData)} - ${formatMonth(req.ended.originalData)}`
                      : req.isGrouped
                        ? req.fieldName === 'Permanent Address'
                          ? formatPermAddress(req.requests, 'originalData')
                          : formatCorrAddress(req.requests, 'originalData')
                        : FILE_FIELDS.includes(req.fieldName)
                          ? renderFileValue(req.originalData)
                          : typeof req.originalData === 'object' &&
                            !Array.isArray(req.originalData)
                            ? extractValue(req.originalData) || 'NA'
                            : YEAR_FIELDS.includes(req.fieldName)
                              ? formatYearOnly(req.originalData)
                              : typeof req.originalData === 'number'
                                ? req.originalData
                                : typeof req.originalData === 'string'
                                  ? renderExpandableDescription(req.originalData, `${req.id}-before`)
                                  : !req.originalData || Object.keys(req.originalData).length === 0
                                    ? 'NA'
                                    : renderValue(req.originalData)


                    let afterContent

                    if (req.isNewItem) {
                      const d = req.requestedData || {}

                      const duration =
                        d.started_in && d.ended_in
                          ? `${formatMonth(d.started_in)} - ${formatMonth(d.ended_in)}`
                          : null
                      const endedon = d.endedOn ? new Date(d.endedOn).getFullYear() : null

                      afterContent = (
                        <AfterStack>
                          {d.title && <AfterTitle>{d.title}</AfterTitle>}
                          {d.role && <AfterTitle>{d.role}</AfterTitle>}
                          {d.resumeName && (
                            <Link
                              onClick={() =>
                                window.open(
                                  typeof d.fileUrl === 'string'
                                    ? d.fileUrl
                                    : d.fileUrl?.url,
                                  '_blank'
                                )
                              }
                            >
                              <AfterTitle style={{ color: '#3249D7' }}>{d.resumeName}</AfterTitle>
                            </Link>
                          )}

                          {duration && (
                            <AfterDuration>{duration}</AfterDuration>
                          )}

                          {Array.isArray(d.skill_set) && d.skill_set.length > 0 && (
                            <>
                              <AfterHeading>Skills</AfterHeading>
                              {d.skill_set.map(s => (
                                <AfterValue key={s.id}>{s.name}</AfterValue>
                              ))}
                            </>
                          )}

                          {d.organization && (
                            <>
                              <AfterHeading>Organization</AfterHeading>
                              <AfterValue>{d.organization}</AfterValue>
                            </>
                          )}

                          {d.function && (
                            <>
                              <AfterHeading>Function</AfterHeading>
                              <AfterValue>{d.function}</AfterValue>
                            </>
                          )}

                          {d.industry && (
                            <>
                              <AfterHeading>Industry</AfterHeading>
                              <AfterValue>{d.industry}</AfterValue>
                            </>
                          )}

                          {Array.isArray(d.awards) && d.awards.length > 0 && (
                            <>
                              <AfterHeading>Awards</AfterHeading>
                              {d.awards.map((a, i) => (
                                <AfterValue key={i}>{a}</AfterValue>
                              ))}
                            </>
                          )}

                          {d.description && (
                            <>
                              <AfterHeading>Description</AfterHeading>

                              {renderExpandableDescription(d.description,`${req.id}-after`)}
                            </>
                          )}

                          {d.institutionName && (
                            <>
                              <AfterHeading>Institution Name</AfterHeading>
                              <AfterValue>{d.institutionName}</AfterValue>
                            </>
                          )}

                          {d.state && (
                            <>
                              <AfterHeading>State</AfterHeading>
                              <AfterValue>{d.state}</AfterValue>
                            </>
                          )}

                          {d.city && (
                            <>
                              <AfterHeading>City</AfterHeading>
                              <AfterValue>{d.city}</AfterValue>
                            </>
                          )}

                          {/* {d.domain && (
                            <>
                              <AfterHeading>Domain</AfterHeading>
                              <AfterValue>{d.domain}</AfterValue>
                            </>
                          )} */}

                          {d.university && (
                            <>
                              <AfterHeading>University</AfterHeading>
                              <AfterValue>{d.university}</AfterValue>
                            </>
                          )}

                          {d.degree && (
                            <>
                              <AfterHeading>Degree</AfterHeading>
                              <AfterValue>{d.degree}</AfterValue>
                            </>
                          )}

                          {d.department && (
                            <>
                              <AfterHeading>Department</AfterHeading>
                              <AfterValue>{d.department}</AfterValue>
                            </>
                          )}

                          {d.specialisation && (
                            <>
                              <AfterHeading>Specialisation</AfterHeading>
                              <AfterValue>{d.specialisation}</AfterValue>
                            </>
                          )}

                          {d.board && (
                            <>
                              <AfterHeading>Board</AfterHeading>
                              <AfterValue>{d.board}</AfterValue>
                            </>
                          )}

                          {endedon && (
                            <>
                              <AfterHeading>Year Of Passing</AfterHeading>
                              <AfterDuration>{endedon}</AfterDuration>
                            </>
                          )}



                          {d.marks && (
                            <>
                              <AfterHeading>Marks</AfterHeading>
                              <AfterValue>{d.marks}</AfterValue>
                            </>
                          )}

                          {Array.isArray(d.skills) && d.skills.length > 0 && (
                            <>
                              <AfterHeading>Skills</AfterHeading>
                              {d.skills.map(s => (
                                <AfterValue key={s.id}>{s.name}</AfterValue>
                              ))}
                            </>
                          )}

                          {typeof d.historyOfArrears === 'number' && d.historyOfArrears > 0 && (
                            <>
                              <AfterHeading>History Of Arrears</AfterHeading>
                              <AfterValue>{d.historyOfArrears}</AfterValue>
                            </>
                          )}

                          {d.markSheetUrl?.url && (
                            <>
                              <AfterHeading>MarkSheet</AfterHeading>

                              <Link
                                onClick={() => window.open(d.markSheetUrl.url, '_blank')}
                              >
                                <AfterValue style={{ color: '#3249D7', cursor: 'pointer' }}>
                                  {d.markSheetUrl.name || 'View Certificate'}
                                </AfterValue>
                              </Link>
                            </>
                          )}

                          {d.certificate?.url && (
                            <>
                              <AfterHeading>Certificate</AfterHeading>

                              <Link
                                onClick={() => window.open(d.certificate.url, '_blank')}
                              >
                                <AfterValue style={{ color: '#3249D7', cursor: 'pointer' }}>
                                  {d.certificate.name || 'View Certificate'}
                                </AfterValue>
                              </Link>
                            </>
                          )}
                        </AfterStack>
                      )
                    } else {
                      afterContent = req.isDurationGroup
                        ? `${formatMonth(req.started.requestedData)} - ${formatMonth(req.ended.requestedData)}`
                        : req.isGrouped
                          ? req.fieldName === 'Permanent Address'
                            ? formatPermAddress(req.requests, 'requestedData')
                            : formatCorrAddress(req.requests, 'requestedData')
                          : FILE_FIELDS.includes(req.fieldName)
                            ? renderFileValue(req.requestedData)
                            : YEAR_FIELDS.includes(req.fieldName)
                              ? formatYearOnly(req.requestedData)
                              : typeof req.requestedData === 'string'
                                ? renderExpandableDescription(req.requestedData, `${req.id}-after`)
                                : extractValue(req.requestedData) || renderValue(req.requestedData)
                    }
                    const renderActionCell = req => {
                      if (req.status === 'APPROVED') {
                        return <ApprovedButton>Approved</ApprovedButton>
                      }

                      if (req.status === 'REJECTED') {
                        return <RejectedButton>Rejected</RejectedButton>
                      }

                      // Default = Pending
                      return (
                        <ActionGroup>
                          <ApproveButton onClick={() => {
                            approveRequestDirect(req)
                          }}>Approve</ApproveButton>
                          <RejectButton onClick={() => {
                            if (actionLoading) return
                            handleRejectClick(req)
                          }}>Reject</RejectButton>
                        </ActionGroup>
                      )
                    }


                    return (
                      <TableRows key={req.id}>
                        <Cells>
                          {req.isNewItem
                            ? `New ${getFieldLabel(req)}`
                            : getFieldLabel(req)}
                        </Cells>
                        <Cells>{beforeValue}</Cells>
                        <Cells>{afterContent}</Cells>
                        <Cells>
                          {renderActionCell(req)}
                        </Cells>
                      </TableRows>

                    )
                  })}
                </Table>
              </>
            )}
          </Wrapper>

          {isModalVisible && (
            <Modal
              open={isModalVisible}
              footer={null}
              centered
              closable={false}
            >
              <div
                style={{
                  width: 770,
                  borderRadius: 10,
                  background: '#fff',
                  padding: 40,
                }}
              >
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={modalContent.image === 'approveImage' ? approveImg : rejectImg}
                    width={156}
                    height={197}
                    alt="modal"
                  />

                  <div
                    style={{
                      fontFamily: 'Plus Jakarta Sans',
                      fontSize: modalContent.actionType === 'reject' ? 20 : 24,
                      lineHeight: '41px',
                      marginTop: 24,
                      color: '#010E30',
                    }}
                  >
                    {modalContent.text}
                  </div>

                  {(modalContent.actionType === 'reject' ||
                    modalContent.actionType === 'reject-group') && (
                      <div style={{ marginTop: 22, textAlign: 'left' }}>
                        <div
                          style={{
                            fontFamily: 'Plus Jakarta Sans',
                            fontSize: 14,
                            fontWeight: 500,
                            marginBottom: 6,
                            color: '#010E30',
                          }}
                        >
                          Reason for Rejection
                        </div>

                        <textarea
                          value={rejectionReason}
                          onChange={e => setRejectionReason(e.target.value.slice(0, 200))}
                          placeholder="Enter Reason for Rejection"
                          style={{
                            width: 684,
                            height: 70,
                            borderRadius: 10,
                            border: '1px solid #E6E7EA',
                            padding: 10,
                            outline: 'none',
                          }}
                          onFocus={e => (e.target.style.border = '1px solid #3249D7')}
                          onBlur={e => (e.target.style.border = '1px solid #E6E7EA')}
                        />

                        <div style={{ fontSize: 12, color: '#6b7280', textAlign: 'right' }}>
                          {rejectionReason.length}/200
                        </div>
                      </div>
                    )}


                  <div style={{ display: 'flex', justifyContent: 'center', gap: 12, marginTop: 30 }}>
                    <button
                      disabled={actionLoading}
                      onClick={handleCloseModal}
                      style={{
                        height: 38,
                        padding: '9px 20px',
                        borderRadius: 10,
                        background: '#FBFAFF',
                        color: '#3249D7',
                        border: '1px solid #E3DEFF',
                        cursor: 'pointer',
                      }}
                    >
                      Cancel
                    </button>

                    <button
                      disabled={actionLoading}
                      onClick={handleConfirmAction}
                      style={{
                        height: 38,
                        padding: '9px 20px',
                        borderRadius: 10,
                        background: '#3249D7',
                        color: '#FBFAFF',
                        border: 'none',
                        cursor: 'pointer',
                      }}
                    >
                      {modalContent.actionType === 'reject' || modalContent.actionType === 'reject-group' ? 'Proceed' : 'Approve'}
                    </button>
                  </div>
                </div>
              </div>
            </Modal>
          )}

          {showSuccess && (
            <>
              <Modal
                open
                footer={null}
                centered
                closable={false}
                className="success-modal"
              >
                <SuccessModalStyle />
                <SuccessPopup>
                  <SuccessIcon>
                    <ApprovedIcon width={80} height={68} />
                  </SuccessIcon>

                  <SuccessText>Approved</SuccessText>

                  <SuccessCloseButton style={{ cursor: 'pointer' }} onClick={() => setShowSuccess(false)}>
                    Close
                  </SuccessCloseButton>
                </SuccessPopup>
              </Modal>
            </>
          )}

          <Modal
            open={previewOpen}
            footer={null}
            centered
            closable={false}
            width={1015}
            bodyStyle={{
              padding: 0,
              height: 535,
              borderRadius: 12,
            }}
            onCancel={() => setPreviewOpen(false)}
          >
            <div
              style={{
                width: '100%',
                height: '100%',
                background: '#fff',
                borderRadius: 12,
                padding: 24,
                boxSizing: 'border-box',
              }}
            >
              {/* Header */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: 24,
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                  <div
                    style={{
                      fontFamily: 'Plus Jakarta Sans',
                      fontWeight: 500,
                      fontSize: 14,
                      lineHeight: '100%',
                    }}
                  >
                    Viewing attachment
                  </div>

                  {/* Resume name box */}
                  <div
                    style={{
                      width: 241,
                      height: 44,
                      border: '1px solid #3249D7',
                      borderRadius: 6,
                      display: 'flex',
                      alignItems: 'center',
                      padding: '0 12px',
                      gap: 8,
                    }}
                  >
                    <PaperClip />

                    <span
                      style={{
                        flex: 1,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {previewResume?.name}
                    </span>

                    {previewResume?.size && (
                      <span
                        style={{
                          fontFamily: 'Plus Jakarta Sans',
                          fontWeight: 500,
                          fontSize: 10,
                          color: '#323538',
                        }}
                      >
                        {(previewResume.size / 1024).toFixed(1)} KB
                      </span>
                    )}
                  </div>
                </div>

                {/* Close Icon */}
                <CloseOutlined
                  onClick={() => setPreviewOpen(false)}
                  style={{
                    fontSize: 16,
                    cursor: 'pointer',
                    color: '#323538',
                    opacity: 0.6,
                    fontWeight: 400,
                  }}
                />
              </div>


              {/* Content Area */}
              <div
                style={{
                  width: 919,
                  height: 397,
                  marginLeft: 38,
                  background: '#F9FAFB',
                  borderRadius: 8,
                  overflow: 'hidden',
                }}
              >
                {previewResume?.url ? (
                  previewResume.format?.toLowerCase() === 'pdf' ? (
                    <iframe
                      src={`${previewResume.url}#toolbar=0&navpanes=0&scrollbar=0`}
                      title="Resume Preview"
                      width="100%"
                      height="100%"
                      style={{ border: 'none' }}
                    />
                  ) : (
                    <img
                      src={previewResume.url}
                      alt="Resume Preview"
                      style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain',
                      }}
                    />
                  )
                ) : (
                  'No preview available'
                )}
              </div>

            </div>
          </Modal>
        </Spin>
      }
    />
  )
}
